<!-- <ul class="pagination" *ngIf="pageList.length > 0">
    <li class="page-item {{(nowIndex == 1)?'disabled':''}}">
     <a class="page-link" href="" (click)="lessPage($event)">
           <i class="fa fa-angle-left"></i>
     </a>
    </li>

    <ng-container *ngFor="let p of pageList">
        <li class="page-item {{(nowIndex == p)?'active':''}}" >
            <a class="page-link" href="#" (click)="setPage($event,p)">{{p}}</a>
        </li>
    </ng-container>

    <li class="page-item {{(nowIndex == pageList.length)?'disabled':''}}">
    <a class="page-link" href="" (click)="addPage($event)">
          <i class="fa fa-angle-right"></i>
    </a>
    </li>
</ul> -->
<!-- 
<div class="paginationBox" *ngIf="pageList.length > 1">
    <div class="pagination">
        <div class="prev {{(nowIndex == 1)?'disabled':''}}" (click)="lessPage($event)">
            <i class="icon icon-arrow_left">&#xe807;</i>
        </div>
    
        <ng-container *ngFor="let p of pageShowList">
            <div class="page {{(nowIndex == p)?'active':''}}" (click)="setPage($event,p)">{{p}}</div>
        </ng-container>
        <div class="page active">1</div>
        <div class="prev">2</div>
        <div class="prev">3</div>
        <div class="next {{(nowIndex == pageList.length)?'disabled':''}}" (click)="addPage($event)">
            <i class="icon icon-arrow_right">&#xe808;</i>
        </div>
        <div class="more" *ngIf="lastindex != 0">...</div>
        <div class="page" *ngIf="lastindex != 0" (click)="setPage($event,lastindex)">{{lastindex}}</div>
    </div>
</div>
 -->

<div class="pagination" *ngIf="pageList.length > 1">
    <div class="first {{(nowIndex == 1)?'disabled':''}}" (click)="setPage($event,1)">
        <i class="icon icon-page_first">&#xe811;</i>
    </div>
    <div class="prev {{(nowIndex == 1)?'disabled':''}}" (click)="lessPage($event)">
        <i class="icon icon-left-open">&#xe801;</i>
    </div>

    <div class="pager">
        <input type="number" class="pageIndex" [value]="nowIndex" (change)="setPageV2($event)"/>
        <div class="pageTotal">/ {{pageTotal}}</div>
    </div>

    <div class="next {{(nowIndex == pageList.length)?'disabled':''}}" (click)="addPage($event)">
        <i class="icon icon-right-open">&#xe800;</i>
    </div>
    <div class="last {{(nowIndex == pageList.length)?'disabled':''}}" (click)="setPage($event,(pageList.length))">
        <i class="icon icon-page_last">&#xe80f;</i>
    </div>
</div>